import React, { useEffect, useState } from 'react';

import {
  Cancel,
  CheckCircle,
  EmailOutlined,
  GitHub,
  LinkedIn,
  PhoneAndroid,
} from '@material-ui/icons';
import { IconButton } from '@material-ui/core';

const BasicInfo = ({ user, data, setData }) => {
  const [verify, setVerify] = useState({});

  useEffect(() => {
    setData({
      ...data,

      linkedInUrl:
        verify.linkedIn === 'yes' ? user.newLinkedInUrl : user.linkedInUrl,
      newLinkedInUrl: null,

      githubUrl: verify.github === 'yes' ? user.newGithubUrl : user.githubUrl,
      newGithubUrl: null,

      resume: verify.resume === 'yes' ? user.newResume : user.resume,
      newResume: null,
    });
    // eslint-disable-next-line
  }, [verify]);

  return (
    <>
      <div className='border border-gray-300 rounded-lg col-span-3'>
        <div className='bg-gray-200 py-2 px-4'>Basic Info</div>

        <p className='text-justify p-4'>{user.about}</p>

        <div className='flex gap-8 px-4'>
          <span className='w-1/5'>
            <PhoneAndroid />
            <span className='ml-2'>{user.phone}</span>
          </span>
          <span>
            <EmailOutlined />
            <span className='ml-2'>{user.email}</span>
          </span>
        </div>

        <div className='flex items-center gap-8 p-4'>
          <span className='w-1/5'>
            <span className='text-3xl text-blue-600 mr-2'>
              <LinkedIn fontSize='inherit' htmlColor='#0077B7' />
            </span>
            <a
              href={user.newLinkedInUrl}
              target='_blank'
              rel='noopener noreferrer'
              className='text-blue-500 underline'
            >
              LinkedIN
            </a>
          </span>

          {user.sentFrom === 'Student' && (
            <>
              <span>
                <span className='text-2xl text-black mr-2'>
                  <GitHub fontSize='inherit' />
                </span>
                <a
                  href={user.newGithubUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-blue-500 underline'
                >
                  GitHub
                </a>
              </span>

              <span className='flex-grow' />

              <span>
                <a
                  href={user.resumeUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-blue-500 border border-gray-300 rounded py-2 px-4'
                >
                  Download Resume
                </a>
              </span>
            </>
          )}
        </div>
      </div>

      {/* verify button */}
      <div className='flex flex-col justify-center w-full'>
        {user.newLinkedInUrl && (
          <div className='flex items-center gap-2 px-4'>
            <span className='flex-grow'>LinkedIN</span>
            <span>
              <IconButton
                onClick={() => setVerify({ ...verify, linkedIn: 'yes' })}
                className='focus:outline-none'
              >
                <CheckCircle
                  htmlColor={verify.linkedIn === 'yes' ? '#76CE65' : 'inherit'}
                />
              </IconButton>
              <IconButton
                onClick={() => setVerify({ ...verify, linkedIn: 'no' })}
                className='focus:outline-none'
              >
                <Cancel
                  htmlColor={verify.linkedIn === 'no' ? '#CC0000' : 'inherit'}
                />
              </IconButton>
            </span>
          </div>
        )}

        {user.sentFrom === 'Student' && (
          <>
            {user.newGithubUrl && (
              <div className='flex items-center gap-2 px-4'>
                <span className='flex-grow'>Github</span>
                <span>
                  <IconButton
                    onClick={() => setVerify({ ...verify, github: 'yes' })}
                    className='focus:outline-none'
                  >
                    <CheckCircle
                      htmlColor={
                        verify.github === 'yes' ? '#76CE65' : 'inherit'
                      }
                    />
                  </IconButton>
                  <IconButton
                    onClick={() => setVerify({ ...verify, github: 'no' })}
                    className='focus:outline-none'
                  >
                    <Cancel
                      htmlColor={verify.github === 'no' ? '#CC0000' : 'inherit'}
                    />
                  </IconButton>
                </span>
              </div>
            )}

            {user.newResume && (
              <div className='flex items-center gap-2 px-4'>
                <span className='flex-grow'>Resume</span>
                <span>
                  <IconButton
                    onClick={() => setVerify({ ...verify, resume: 'yes' })}
                    className='focus:outline-none'
                  >
                    <CheckCircle
                      htmlColor={
                        verify.resume === 'yes' ? '#76CE65' : 'inherit'
                      }
                    />
                  </IconButton>
                  <IconButton
                    onClick={() => setVerify({ ...verify, resume: 'no' })}
                    className='focus:outline-none'
                  >
                    <Cancel
                      htmlColor={verify.resume === 'no' ? '#CC0000' : 'inherit'}
                    />
                  </IconButton>
                </span>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default BasicInfo;
